export const OrderDetailsConfigWholesale = {
  activities: true,
  orderNumber: true,
  doors: true,
  salesDocType: true,
  poRef: true,
  deliveryDate: true,
  createdBy: true,
  createdDate: true,
  notes: true,
  updatedBy: true,
  updatedDate: true
}

export const OrderDetailsConfigRetail = {
  activities: true,
  orderNumber: true,
  doors: true,
  salesDocType: false,
  poRef: false,
  deliveryDate: false,
  createdBy: true,
  createdDate: true,
  notes: true,
  updatedBy: true,
  updatedDate: true
}
